import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DriverLocationViewComponent } from './driver-location-view.component';
import { AutoCompleteModule, TableModule } from 'primeng';
import { DragDropModule } from '@angular/cdk/drag-drop';

const routes: Routes = [
  { path: '', component: DriverLocationViewComponent, data: { title: 'Driver Location' } },
  {
    path: ':id',
    component: DriverLocationViewComponent,
    data: { title: 'Supplier Schedule View' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DriverLocationViewRoutingModule {}

@NgModule({
  imports: [
    DriverLocationViewRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
    AutoCompleteModule,
    DragDropModule,
  ],
  declarations: [DriverLocationViewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DriverLocationViewModule {}
